// Generated from src/img/svg/mask.svg

export const Mask = (props) => {
  return (
    <svg viewBox="0 0 64 64" {...props}>
      <g className="mask_svg__icon-poster" fill="none" fillRule="evenodd">
        <g className="mask_svg__icon-style">
          <path
            d="m16 26 16-5 16 5v12l-8 6-8 2-8-2-8-6z"
            fill="#fff"
            stroke="#fff"
          />
          <path
            className="mask_svg__base"
            d="M52.945 18.674a1 1 0 0 1-.618 1.271c-1.745.603-3.001 2.714-3.241 4.655q-.068.51-.081 1.03l-.003.349v10.366c2.208-2.734 3.949-6 5.04-9.633a1 1 0 0 1 1.916.576c-1.434 4.768-3.92 8.961-7.109 12.24a1 1 0 0 1-.313.317l-.24.237C43.84 44.408 38.113 47 32 47c-6.225 0-12.048-2.688-16.537-7.157a1 1 0 0 1-.312-.314c-3.189-3.28-5.675-7.473-7.108-12.24a1 1 0 0 1 1.915-.577c1.092 3.633 2.832 6.9 5.042 9.634v-6.168l-.001-.032V26.18a10 10 0 0 0-.084-1.367 4.98 4.98 0 0 0-3.253-4.018 1 1 0 0 1 .676-1.881 6.98 6.98 0 0 1 4.52 5.376q.201-.102.42-.173l13.72-3.975a3.6 3.6 0 0 1 1.757-.062l.247.062 13.518 3.915q.31.082.593.219l-.01.07c.323-2.613 1.98-5.395 4.572-6.29a1 1 0 0 1 1.271.618zm-21.214 3.349-.176.04-13.56 3.927c-.533.141-.92.593-.985 1.116l-.01.132V38.55C21.115 42.588 26.395 45 32 45s10.886-2.412 15-6.45V27.257a1.34 1.34 0 0 0-.88-1.23l-.136-.043-13.537-3.92a1.6 1.6 0 0 0-.716-.041"
            fill="#282D37"
            fillRule="non-zero"
          />
          <path
            className="mask_svg__pulse"
            d="M43.767 33.358a1 1 0 0 1-.124 1.409 18.125 18.125 0 0 1-23.285 0 1 1 0 1 1 1.285-1.533 16.125 16.125 0 0 0 20.715 0 1 1 0 0 1 1.409.124M38.8 27.4a1 1 0 0 1-.2 1.4 11 11 0 0 1-13.2 0 1 1 0 0 1 1.2-1.6 9 9 0 0 0 10.8 0 1 1 0 0 1 1.4.2"
            fill="#EC0016"
          />
        </g>
      </g>
    </svg>
  );
};
